import React, { useState, useCallback, useContext } from 'react'
import { createUseStyles } from 'react-jss'
import cn from 'classnames'
import ResponsiveImage from '../ResponsiveImage'
import { sliceMarginStyles, span } from '../../style/span'
import theme from '../../style/theme'
import { vw } from '../../style/vw'
import SplitWordsAnimation from '../SplitWordsAnimation'
import get from 'lodash/get'
import ColorContext from '../ColorContext'
import { useSelector } from 'react-redux'
import { getPageSlices } from '../../redux/slices/content'
import last from 'lodash/last'
// import { width } from '../../style/breakpoints'

const SimplePageHero = ({ className, slice }) => {
  const { title, copy, image } = slice
  const slices = useSelector(getPageSlices)
  const { borderColor } = useContext(ColorContext)
  const classes = useStyles({ color: get(image, ['palette', 'dominant', 'title']), borderColor })
  const [ready, setReady] = useState(!image)
  const onImageLoaded = useCallback(() => { setReady(true) }, [])

  return (
    <section className={cn(classes.section, { withoutImage: !image, withoutMargin: last(slices) === slice })}>
      {image && <ResponsiveImage {...image} className={classes.image} onImageLoaded={onImageLoaded} parallax={theme.parallax} />}
      {title && (
        <SplitWordsAnimation ready={ready}>
          <h1 className={classes.title}>
            {title}
          </h1>
        </SplitWordsAnimation>
      )}
      {copy && <p className={classes.copy}>{copy}</p>}
    </section>
  )
}

const useStyles = createUseStyles({
  section: {
    margin: 'auto',
    // maxWidth: 'calc(100% - 7rem)',
    width: '100%',
    extend: [sliceMarginStyles],
    position: 'relative',
    padding: [0, span(0.5)],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '100vh',
    color: ({ color }) => color || 'currentColor',
    borderColor: ({ borderColor }) => borderColor,
    [theme.breakpoints.up('md')]: {
      padding: [0, span(1, 'md'), 0]
    },
    // '@media (max-width: 1500px)': {
    //   maxWidth: 'calc(100% - 7rem)'
    // },
    // '@media (max-width: 1024px)': {
    //   maxWidth: 'calc(100% - 7rem)'
    // },
    // '@media (max-width: 600px)': {
    //   maxWidth: 'calc(100% - 3.5rem)'
    // },
    '&.withoutImage': {
      // maxWidth: 'calc(100% - 2rem)',
      minHeight: 'auto',
      marginBottom: 0,
      borderBottomWidth: 0,
      borderBottomStyle: 'solid',
      // padding: [vw(100), span(1), 0],
      [theme.breakpoints.up('md')]: {
        // padding: [0, span(3, 'md')]
      }
    },
    '&.withoutMargin': {
      maxWidth: 'calc(100% - 9rem)',
      marginBottom: 0
    }
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(51,51,51,0.3)'
    }
  },
  title: {
    position: 'relative',
    margin: [vw(138, 'mobile'), 0, vw(40, 'mobile')],
    fontSize: vw(54),
    [theme.breakpoints.up('md')]: {
      fontSize: vw(100, 'desktop'),
      maxWidth: span(11),
      margin: [vw(200, 'desktop'), 0, vw(80, 'desktop')]
    },
    '& > *': {
      margin: 0
    }
  },
  copy: {
    fontFamily: 'Questa Sans',
    fontWeight: '400',
    position: 'relative',
    fontSize: vw(14),
    [theme.breakpoints.up('md')]: {
      fontFamily: 'Morion',
      fontWeight: '600',
      maxWidth: vw(435, 'desktop'),
      fontSize: vw(16, 'desktop'),
      lineHeight: 1.6,
      marginBottom: vw(34, 'desktop')
    },
    '@media (max-width: 400px)': {
      margin: '0px'
    }
  },
  icon: {
    float: 'left',
    padding: ['0.03em', 0, '0.2em'],
    '& path': {
      fill: 'currentColor'
    }
  }
}, { name: 'SimplePageHero' })

export default SimplePageHero
